import { Controller } from '@hotwired/stimulus';

import ajax from '@/modules/ajax';

export default class extends Controller {
  static targets = ['vote', 'voteQuestion', 'voteThanks'];
  static values = { visitUrl: String, voteUrl: String };

  connect() {
    ajax({ keepalive: true, method: 'POST', sameOrigin: true, skipNotify: true, url: this.visitUrlValue });
  }

  vote(event) {
    const button = event.currentTarget;
    const value = event.params.value;

    ajax({
      body: { value },
      done: () => this.#onVote(button, value),
      method: 'POST',
      sameOrigin: true,
      skipNotify: true,
      url: this.voteUrlValue,
    });
  }

  #onVote(button, value) {
    this.voteTargets.forEach((item) => {
      const otherValue = item === button ? value : !value;
      const hoverBg = otherValue ? 'hover:bg-support-soft' : 'hover:bg-error-soft';
      const hoverText = otherValue ? 'hover:text-support' : 'hover:text-error';

      item.classList.remove('bg-support-dark', 'bg-error', 'text-white');
      item.classList.add(hoverBg, hoverText);
      item.removeAttribute('disabled');
      item.setAttribute('aria-pressed', 'false');
    });

    const hoverBg = value ? 'hover:bg-support-soft' : 'hover:bg-error-soft';
    const hoverText = value ? 'hover:text-support' : 'hover:text-error';

    button.setAttribute('disabled', '');
    button.setAttribute('aria-pressed', 'true');
    button.classList.remove(hoverBg, hoverText);
    button.classList.add(value ? 'bg-support-dark' : 'bg-error', 'text-white');

    if (this.hasVoteQuestionTarget) this.voteQuestionTarget.classList.add('hidden');
    if (this.hasVoteThanksTarget) this.voteThanksTarget.classList.remove('hidden');
  }
}
